import React, { useContext } from 'react';

import { useRefinementList } from 'react-instantsearch-hooks-web';

import { DiscoverContext } from '../../../../context/DiscoverContext';
import { Tabs } from '../Tabs';

const ControlledTabs = ({ attribute, withLinks = false }) => {
  const { searchState } = useContext(DiscoverContext);

  const refinement =
    searchState?.refinementList && searchState?.refinementList[attribute]
      ? searchState?.refinementList[attribute]
      : null;
  const selectedItem = refinement ? (Array.isArray(refinement) ? refinement[0] : refinement) : '';

  const { refine } = useRefinementList({
    attribute: attribute,
  });

  return <Tabs selectedItem={selectedItem} refine={withLinks ? undefined : refine} />;
};

export default ControlledTabs;
